import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import { siteAccent } from '../styledComponents/variables/colors';
import Button from './Button';
import Date from '../Date';

const PostLinkDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const TitleLink = styled(Link)`
  /* text-decoration: none; */
  h1 {
    line-height: 2rem;
    border-bottom: 2px solid transparent;
    margin-bottom: 0.8rem;
    &:hover {
      color: ${siteAccent};
      border-bottom: 2px solid ${siteAccent};
    }
    transition: border-bottom 0.2s, color 0.2s;
  }
`;

export default ({ post }) => {
  let { path, title, date } = post.frontmatter;
  console.log(post);
  return (
    <PostLinkDiv>
      <TitleLink to={path}>
        <h1>{title}</h1>
      </TitleLink>
      <Date date={date} />
      <p>{post.excerpt}</p>
      <Button to={path}>CONTINUE READING</Button>
    </PostLinkDiv>
  );
};



// WEBPACK FOOTER //
// ./src/components/PostLink/index.js